import { render, staticRenderFns } from "./EditCustomerModal.vue?vue&type=template&id=fc67fd38&scoped=true&"
import script from "./EditCustomerModal.vue?vue&type=script&lang=js&"
export * from "./EditCustomerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc67fd38",
  null
  
)

export default component.exports